import CustomerOnboardingPage from './CustomerOnboardingPage';

export default CustomerOnboardingPage;

